<template>
  <div class="basic_con">
    <Frame title="关联企业">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <el-table :data="tableData" border style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center"
            >
            </el-table-column>

            <el-table-column
              prop="relationName"
              label="公司名称"
              align="center"
            >
            </el-table-column>
          </el-table>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import * as api from "@/api/factoring/factoringCustomer";

export default {
  name: "relationEnterprise",
  components: {
    Frame,
  },
  data() {
    return {
      tableData: [],
    };
  },
  mounted() {
    this.queryTableData();
  },
  methods: {
    async queryTableData() {
      this.loading = true;
      let params = {
        custId: this.$route.params.id,
      };
      let res = await api.getCustralationcompanybl(params);
      if (res.data.code == 200) {
        let data = res.data.data;

        this.tableData = data;
        // this.page.total = res.data.data.total;
        this.loading = false;
      } else {
        this.$message.error(res.data.msg);
        this.loading = false;
      }
    },
    // btnClick() {
    //   this.$emit("fatherEvent", "foodNews");
    // },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  height: 397px;
}
.con_wrapper {
  padding: 10px 20px;
}
/deep/ .el-table th {
  background: #ffffff;
  color: #999999;
}
/deep/ .el-table {
  font-size: 12px;
}
</style>

